import React from 'react'
import { Input } from '@ow/comps'

export default function (opts) {
  return (
    <Input
      name={opts.slug}
      autoComplete="off"
      className="input form-input flex-1"
      style={{
        paddingLeft: '0.75rem',
        paddingRight: '0.75rem',
        fontSize: '0.8125rem',
      }}
      readonly={opts.readonly}
      disabled={opts.onlyShow}
      placeholder="无法找到渲染器, 默认渲染"
      // ref={ref}
    />
  )
}
